import { configureStore } from "@reduxjs/toolkit";
import auth from "./auth.slice";
import country from "./country.slice";
import language from "./language.slice";
import currency from "./currency.slice";
import bundlesReducer from "./bundle.slice"

const store = configureStore({
    reducer:{
        auth,
        country,
        language,
        currency,
        bundlesReducer
    }
});

export default store